import { GridColDef } from "@mui/x-data-grid";
import { renderActive } from "../../../../component/list/table-column-renders";

export const columns: GridColDef[] = [
    { field: 'surveyTitle', headerName: 'Title', flex: 2 },
    { field: 'questions', headerName: 'Questions', flex: 0.5 },
    { field: 'active', headerName: 'Active', flex: 0.5, renderCell: (params) => { return renderActive(params.row.active) } }
];